import React, { Component } from 'react';
import { Switch, Spin, Tooltip, Modal, Button, notification } from 'antd';
import formDataSchema from '../../schema/profile';
import Inputlayer from '../../components/FormComponent/Input';
import Storage from '../../services/local-store';
import networkList from '../../constants/networkList';
import postService from '../../services/httpService';
const $ = require('jquery');

class Profile extends Component {
    constructor(props) {
        super(props)
        this.state = {
            user_name: "",
            role: "",
            user_id: "",
            unit: "",
            gender: "",
            dob: "",
            phone_number: "",
            counselling_station_name: "",
            loadding: false,
            btnloading: false,
            formData: [],
            date: new Date()
        }
        
    }

    componentDidMount() {
        this.getprofile();
        // this.date();
        let formSchema = Object.assign({}, formDataSchema);
        formSchema['feilds'].map((feild, key) => {
            formSchema['feilds'][key]['value'] = null;
            formSchema['feilds'][key]['valid'] = false;
            formSchema['feilds'][key]['errors'] = [];
            delete formSchema['feilds'][key]['text'];

        })
        this.setState({ 'formData': formSchema['feilds'] });
    }

    componentWillUnmount() {
        // this.setState({
        //     formData: []
        // });
    }
    // API
    getprofile = () => {
        try {
            const { getProfileDetails } = networkList;
            var id = JSON.parse(Storage.get('id'))
          
            this.setState((state) => ({ thead: this.state.tableHead, loadding: true }), () => {
                postService(getProfileDetails, 'POST', { id }).then(res => {
                  
                    if (res.status) {
                        this.setState((state) => ({
                            "user_name": res.data[0].username || '--',
                            "role": res.data[0].rolename || '--',
                            "unit": res.data[0].unitname || '--',
                            "counselling_station_name": res.data[0].counselling_station_name || '--',
                            "gender": res.data[0].gender || '--',
                            "dob": res.data[0].dob || '--',
                            "phone_number": res.data[0].phone_number || '--',
                            message: res.message,
                            loadding: false
                        }));
                    }
                    else {
                        // to catch api errors like --> network,url,outof status 1,0
                        Modal.error({
                            title: 'Failure',
                            content: "Oops! something went wrong... Please try again."
                        });
                    }
                })
            });
        } catch (error) {
          
            Modal.error({
                title: 'Failure',
                content: "Oops, something went wrong... Please try again.",
            });
        }
    }
   
    updatepassword = () => {
        const { changeProfilePassword } = networkList;
        const id = JSON.parse(Storage.get('id'));      
        var formFeilds = this.state.formData;
        let errors = this.validateModalFeilds(formFeilds)
        // let data={
        //     "id": id,
        //     "password": formFeilds[0].value,
        //     "new_password": formFeilds[2].value,
        //     "updated_at": this.state.date        
        // }
       
        // console.log('data', data)
        this.setState({
            "id": id,
            "password": formFeilds[0].value,
            "new_password": formFeilds[1].value,
            "confirm_password": formFeilds[2].value,
            "updated_at": this.state.date    
        })
        if (!errors.includes(false)) {           
           if(formFeilds[1].value === formFeilds[2].value){
            this.setState((state) => ({ btnloading: true }), () => {
                postService(changeProfilePassword, 'POST', {
                    "id": this.state.id,
                    "password": this.state.password,
                    "new_password": this.state.confirm_password,
                    "updated_at": this.state.date
                  }).then(res => {                   
                    if (res.status) {
                        // alert('Data inserted');
                     
                        this.setState((state) => ({ btnloading: false, visible: false }));
                        // Modal.success({
                        //     title: 'Success',
                        //     content: "Successfully Updated",
                        // });
                        notification.success({
                            message: 'Success',
                            description: res.message,
                            duration: 3,
                            top: 20,
                            right: 0
                        });
                       this.logout()
                    } else {
                        // alert('Data not inserted');
                        this.setState({btnloading:false})
                        // Modal.error({
                        //     title: 'Failure',
                        //     content: res.message? res.message:'Oops! something went wrong... Please try again.',
                        // });
                        notification.error({
                            message: 'Failure',
                            description: res.message? res.message:'Oops! something went wrong... Please try again.',
                            duration: 3,
                            top: 20,
                            right: 0
                        });
                    }
                })
            });
           }else{
            notification.error({
                message: 'Failure',
                description: 'New password and confirm password are not matching.',
                duration: 3,
                top: 20,
                right: 0
            });
           }
            let formSchema = Object.assign({}, formDataSchema);
            formSchema['feilds'].map((feild, key) => {
                formSchema['feilds'][key]['value'] = null;
                formSchema['feilds'][key]['valid'] = false;
                formSchema['feilds'][key]['errors'] = [];
                delete formSchema['feilds'][key]['text'];
            })
            this.setState({ 'formData': formSchema['feilds'] });
        }
    }
    logout = () => {
        const { logout } = networkList;
        const id = JSON.parse(Storage.get('id'));
        // let data={
        //     "id": id,               
        // }
        // console.log('data', data)
        this.setState({
            "id": id,
        })
        try {
            this.setState((state) => ({ btnloading: true }), () => {
                postService(logout, 'GET', {
                    "id": this.state.id,
                }).then(res => {
                    if (res.status) {
                        // alert('Data inserted');
                        // console.log('res', res)
                        // this.setState((state) => ({ btnloading: false, visible: false }));
                        // Modal.success({
                        //     title: 'Success',
                        //     content: "Successfully Updated",
                        // });
                        // notification.success({
                        //     message: 'Success',
                        //     description: res.message,
                        //     duration: 3,
                        //     top: 20,
                        //     right: 0
                        // });
                    } else {
                        // alert('Data not inserted');
                        // this.setState({btnloading:false})
                        // Modal.error({
                        //     title: 'Failure',
                        //     content: res.message? res.message:'Oops! something went wrong... Please try again.',
                        // });
                        // notification.error({
                        //     message: 'Failure',
                        //     description: res.message? res.message:'Oops! something went wrong... Please try again.',
                        //     duration: 3,
                        //     top: 20,
                        //     right: 0
                        // });
                    }
                    this.clearAll()
                })
            });
        } catch (error) {
          
            Modal.error({
                title: 'Failure',
                content: "Oops, something went wrong... Please try again.",
            });
        }

    }
    // API ending
    clearAll() {
        Storage.clearAll();
        this
            .props
            .history
            .push(`/login`);
    }
    date = () => {
        var monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
            'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        var that = this;
        var date = new Date().getDate(); //Current Date
        var month = monthNames[new Date().getMonth()]; //Current Month
        var year = new Date().getFullYear(); //Current Year

        that.setState({
            //Setting the value of the date time
            date:
                date + ' ' + month + ' ' + year,
        });
    }
    handleChange(ele) {
      
        if (ele) {
            this
                .state
                .formData
                .map((data, key) => {

                });
        }
    }

    validateModalFeilds(formFeilds) {
        let errors = [];
        let role_id = null;
        formFeilds.map((feild, key) => {
            if (feild['element'] === 'input' || feild['element'] === 'select2' || feild['element'] === 'date') {
                if (feild['name'] === 'role_id' && feild['value'] === 'RL_fm8f') {
                    role_id = true;
                } else {
                    role_id = false;
                }
                formFeilds[key]['errors'] = [];
                if (!feild.disable) {
                    feild
                        .rules
                        .map((rule, rkey) => {
                            if (rule.test !== undefined && typeof rule.test === 'function' && !rule.test(feild['value'])) {
                                formFeilds[key]['errors'].push({ 'message': rule.message });
                                errors.push(false);
                            }
                        })
                }                 
            }
            if (role_id !== null && role_id) {

            }
        })

        this.setState((state) => ({ formData: formFeilds }));
        return errors;
    }
    render() {
        let { user_name, user_id, dob, gender, phone_number, counselling_station_name, unit, role, formData } = this.state
      
        return (
            <div className="card p-5">
                <Spin spinning={this.state.loadding}>
                    <h1 className="text-heading text-center text-capitalize pb-5">{(user_name !== null) ? user_name : "--"}</h1>
                    <div className="row mx-auto pb-3">
                        <div className="col-xl-4 col-lg-4 col-sm-6 d-flex">
                            <p className="data-label">User ID </p>
                            <p className="data-item">: {(user_id !== null) ? (user_id !== "") ? user_id : "--" : "--"}</p>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-sm-6 d-flex">
                            <p className="data-label">Gender </p>
                            <p className="data-item">: {(gender !== null) ? (gender !== "") ? gender : "--" : "--"}</p>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-sm-6 d-flex">
                            <p className="data-label">Phone </p>
                            <p className="data-item">: {(phone_number !== null) ? (phone_number !== "") ? phone_number : "--" : "--"}</p>
                        </div>                       
                        <div className="col-xl-4 col-lg-4 col-sm-6 d-flex">
                            <p className="data-label">Unit </p>
                            <p className="data-item">: {(unit !== null) ? (unit !== "") ? unit : "--" : "--"}</p>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-sm-6 d-flex">
                            <p className="data-label">role </p>
                            <p className="data-item">: {(role !== null) ? (role !== "") ? role : "--" : "--"}</p>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-sm-6 d-flex">
                            <p className="data-label">Work Station</p>
                            <p className="data-item">: {(counselling_station_name !== null) ? (counselling_station_name !== "") ? counselling_station_name : "--" : "--"}</p>
                        </div>
                    </div>
                    <div className="row mx-auto pb-5">
                        {(formData !== undefined) && <React.Fragment>

                            {formData
                                .map((feild, key) => {

                                    if (feild.element === 'input') {
                                        return (
                                            <div
                                                className={`${feild.className
                                                    ? feild.className
                                                    : 'col'} my-2 ${feild.name}`}
                                                key={key}>
                                                <div className="clearfix">
                                                    <p className="data-label w-100 mb-1">{feild.title}</p>
                                                </div>
                                                <Inputlayer
                                                    {...this.props}
                                                    {...this.state}
                                                    feildData={feild}
                                                    onInputChanges={this
                                                        .handleChange
                                                        .bind(this)}
                                                />
                                                {feild
                                                    .errors
                                                    .map((error, eKey) => {
                                                        return (
                                                            <small key={eKey} className="form-text text-danger">{error.message}</small>
                                                        );
                                                    })}
                                            </div>
                                        )
                                    }
                                })}
                        </React.Fragment>
                        }
                    </div>
                    <div className="row justify-content-center">                      
                        <Button className="btn btn-success text-capitalize mr-3" onClick={this.updatepassword} btnloading={this.state.btnloading}>submit</Button>
                        {/* <Button className="btn btn-success btn-next text-capitalize">cancel</Button>                         */}
                    </div>
                    <div className="row mx-auto pt-5">
                        <p className="mb-0 text-black" style={{ fontSize: 13 + 'px', lineHeight: 2, backgroundColor: 'transparent' }}><span className="data-label" style={{ fontSize: 15 + 'px', lineHeight: 2 }}>Note:</span> You would be logged out after password change.</p>
                        </div>
                </Spin>
            </div>
        )

    }
}
export default Profile;